import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'secondsToTime'
})
export class SecondsToTimePipe implements PipeTransform {

  transform(value: number): string {
    return moment.utc(moment.duration(value, 'seconds').asMilliseconds()).format('HH:mm:ss');
  }

}
